export default {
    title_list: 'Страны',
    title_page: 'Страна',
    title_create_page: 'Создать страну',
    title_edit_page: 'Изменить страну',

    filter: {
        labels: {
            title: 'Название',
            code2: 'Код страны',
            position: 'Порядок',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Название',
            code2: 'Код страны',
            position: 'Порядок',
        }
    },

    buttons: {

    },

    form: {
        title: 'Название',
        code2: 'Код страны',
        position: 'Порядок',
    },
}
